var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95401 31.046 5.63657e-06 20 5.63657e-06C16.8947 -0.00232729 13.8316 0.719551 11.0541 2.10829C8.27667 3.49703 5.86132 5.51436 4 8.00001V3.00001H0V15H12V11H6.77C8.92446 7.8323 12.144 5.54276 15.8434 4.54753C19.5428 3.5523 23.4765 3.91744 26.9295 5.5766C30.3825 7.23575 33.1256 10.0788 34.6602 13.5889C36.1948 17.0991 36.419 21.0433 35.2921 24.7047C34.1652 28.3662 31.762 31.5018 28.5192 33.5415C25.2765 35.5813 21.4095 36.3899 17.6212 35.8203C13.8328 35.2508 10.3745 33.3408 7.87497 30.4377C5.3754 27.5346 4.00044 23.8309 4 20H0C0 31.046 8.954 40 20 40C31.046 40 40 31.046 40 20ZM17.554 13.036L26.752 19.168C26.889 19.2593 27.0013 19.3831 27.0789 19.5282C27.1566 19.6733 27.1972 19.8354 27.1972 20C27.1972 20.1646 27.1566 20.3267 27.0789 20.4718C27.0013 20.617 26.889 20.7407 26.752 20.832L17.554 26.964C17.4034 27.0642 17.2285 27.1217 17.0478 27.1303C16.8671 27.139 16.6875 27.0985 16.528 27.0131C16.3685 26.9277 16.2352 26.8007 16.1422 26.6455C16.0492 26.4904 16.0001 26.3129 16 26.132V13.868C16.0001 13.6871 16.0492 13.5096 16.1422 13.3545C16.2352 13.1993 16.3685 13.0723 16.528 12.9869C16.6875 12.9015 16.8671 12.861 17.0478 12.8697C17.2285 12.8783 17.4034 12.9358 17.554 13.036Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/img6.dee1fdb014f674ce3f48cfa51d6e335e.svg";
export { ForwardRef as ReactComponent };